"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNever = exports.parseErrorToString = void 0;
/**
 * Parses an error to a friendly error message string.
 * @param error - The error to parse (can be Error, string, or unknown object).
 * @returns A friendly error message string suitable for re-throwing.
 */
function parseErrorToString(error) {
    if (error instanceof Error) {
        // TypeScript Error with message and stack.
        return error.stack ? error.stack : error.message;
    }
    else if (typeof error === "string") {
        // Error is a string.
        return error;
    }
    else {
        // Unknown object, null, or undefined.
        return "Unknown error";
    }
}
exports.parseErrorToString = parseErrorToString;
/**
 * Used to throw an error for what should be unreachable code that can be based on a particular
 * value in a switch statement for example.
 *
 * @param x The value that caused an unreachable piece of code.
 */
function assertNever(x) {
    throw new Error("Unreachable code reached: " + x);
}
exports.assertNever = assertNever;
